import { Mail, MapPin, Phone, Truck } from "lucide-react";

const contactItems = [
  {
    label: "Email",
    value: "sahilsalhaj123@gmail.com",
    href: "mailto:sahilsalhaj123@gmail.com",
    icon: Mail
  },
  {
    label: "Phone",
    value: "7975897308",
    href: "tel:7975897308",
    icon: Phone
  },
  {
    label: "Location",
    value: "Bangalore, India",
    icon: MapPin
  },
  {
    label: "Delivery",
    value: "Ships pan-India",
    icon: Truck
  }
];

export function Footer() {
  return (
    <footer className="mt-14 border-t border-white/[0.08] bg-background/70">
      <div className="container-pad grid gap-7 py-9 sm:grid-cols-[0.9fr_1.1fr] sm:items-center">
        <div>
          <p className="font-display text-lg font-semibold tracking-wide">RevLane</p>
          <p className="mt-2 max-w-md text-sm leading-6 text-muted-foreground">
            Premium collector listings, direct checkout, and careful fulfillment from Bangalore.
          </p>
        </div>
        <div className="grid gap-3 sm:grid-cols-2">
          {contactItems.map((item) => {
            const Icon = item.icon;
            const content = (
              <span className="flex min-w-0 items-center gap-3 rounded-md border border-white/[0.08] bg-card/50 px-3 py-3 transition group-hover:border-accent/35">
                <Icon className="h-4 w-4 shrink-0 text-accent" />
                <span className="min-w-0">
                  <span className="block text-[11px] uppercase tracking-[0.2em] text-muted-foreground">{item.label}</span>
                  <span className="mt-0.5 block break-words text-sm text-foreground">{item.value}</span>
                </span>
              </span>
            );

            return item.href ? (
              <a key={item.label} href={item.href} className="group block">
                {content}
              </a>
            ) : (
              <div key={item.label}>{content}</div>
            );
          })}
        </div>
      </div>
    </footer>
  );
}
